import React, {FC, memo, useEffect, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {AppDispatch, IRootState} from "../../store/configureStore";
import {actions} from "../../store/sliceModal";
import {BirthdayInputGroup, BirthdayPageArticle, BirthdayPageContainer} from "./BirthdayPageStyle";
import {Button, Form, InputGroup} from "react-bootstrap";
import {fetchAllPersons} from "../../fetch/RequestBirthday";
import BirthdayCard from "../../component/birthday/BirthdayCard";
import {IPerson} from "../../store/slicePerson";
import {actions as actionApp} from "../../store/sliceApp";

const BirthdayPage: FC = () => {
    const dispatch = useDispatch<AppDispatch>();
    const  persons  = useSelector((state: IRootState) => state.person.persons)

    const [searchName, setSearchName] = useState<string>('')
    useEffect(() => {
        dispatch(actionApp.setBirthday())
        fetchAllPersons();
    }, [])

    const filter = (person: IPerson, subsrt: string): boolean => {
        if (subsrt === '' || person.name.toLowerCase().includes(subsrt?.toLowerCase())) {
            return true;
        }
        return false;
    }

    return (
        <BirthdayPageContainer>
            <>
                <BirthdayInputGroup>
                    <Form.Control
                        placeholder="Поиск"
                        value={searchName}
                        onChange={(event) => setSearchName(event.target.value)}
                    />
                    <Button variant="outline-secondary"
                    onClick={() => dispatch(actions.showPersonModal({} as IPerson))}>
                        Создать
                    </Button>
                </BirthdayInputGroup>
                {Array.isArray(persons) &&
                       persons?.filter((person: IPerson) => filter(person, searchName)).map((person : IPerson) =>
                        <BirthdayCard person={person}/>
                    )
                }
            </>
        </BirthdayPageContainer>


    )
}


export default memo(BirthdayPage)

